export const documentationYear = [2024] as const;
export type DocumentationYear = (typeof documentationYear)[number];

export interface DocumentationCategory {
    year: number;
    category: string[];
}

export const documentationCategories: DocumentationCategory[] = [
    {
        year: 2024,
        category: ['All', 'Coding', 'Innovative', 'Sumo', 'Obstacle', 'Student Symposium'],
    },
    {
        year: 2025,
        category: ['All','Python Coding','Scratch Coding','Duel in Vibe Coding','Obstacle for Creating UI/UX Mobile Application','Student Symposium','Innovative Technology Challenge'],
    },
    {
        year: 2026,
        category: [],
    }
];

